export default function bindArg(func, bindValue) {
  return typeof func === 'function' ? arg => func(Object.assign({
    bindValue
  }, arg)) : undefined;
}